import React from 'react';
import {
  basePatchQuery,
  uploadSingleImage,
} from '../../../../utility/sb-api/sb-api.service';
import { closeModalSafely as closeModalSafelyBase } from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  uploadImage,
  targetStore,
  setIsSubmitting,
  closeModal,
  onSubmit,
  suppressNotification,
) => {
  if (!errors?.length > 0) {
    setIsSubmitting(true);

    (uploadImage
      ? uploadSingleImage(uploadImage, targetStore.id).then((res) => res.id)
      : Promise.resolve(targetStore?.logo?.id || null)
    )
      .then((imageId) => {
        const preparedValues = {
          logoImageId: imageId,
        };

        // Store endpoint is manager/stores/:id (not store-scoped)
        const path = `manager/stores/${targetStore.id}`;

        return basePatchQuery(
          path,
          preparedValues,
          null,
          !suppressNotification && 'editStoreLogoSuccess',
          !suppressNotification && 'editStoreLogoError',
        );
      })
      .then(() => {
        onSubmit();
        setIsSubmitting(false);
        closeModal();
      })
      .catch(() => setIsSubmitting(false));
  } else {
    console.error('No uploadImage specified');
  }
};
